import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PwdReset_ConfirmReset.html?raw';
import Edit from '../../UI/Edit/Edit';
import "../../UI/Edit/Edit";
import Button from '../../UI/Button/Button';
import "../../UI/Button/Button";
import PasswordChangeForm from '../../UI/PasswordChange/PasswordChangeForm';
import"../../UI/PasswordChange/PasswordChangeForm";
import { TranslationHelpers } from "../../../more/Helpers";
//import DataItems = require("DataItems");



interface PwdReset_ConfirmationData {
    identifierKey: string;
    confirmationCode: string;
    newPassword: string;
}
class PwdReset_ConfirmReset extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private confirmationData: PwdReset_ConfirmationData;

    private confirmationCodeInput: MdsLax<InstanceType<typeof Edit>>;
    
    private submitBtn: MdsLax<InstanceType<typeof Button>>;

    // diverse Node:
    private pwChangeContainer: HTMLElement;
    private passwordChangeForm: MdsLax<InstanceType<typeof PasswordChangeForm>>;
    private sectionInputForm: HTMLDivElement;
    private sectionResetComplete: HTMLDivElement;
    private sectionErrorMessage: HTMLDivElement;
    private txtErrorMessage: HTMLSpanElement;
    private txtResetCompleteMessage: HTMLParagraphElement;

    private _onClick_Submit(evt): void {
        this.sendRequest();
    }
    sendRequest(): void {

        let data = this.passwordChangeForm.getSubmitData();

        this.confirmationData = {
            confirmationCode: this.confirmationCodeInput.getValue(),
            identifierKey: this.getUrlParameterValue("guid"),
            newPassword: data.newPassword
        };

        //console.log("confirmationdata", this.confirmationData);

        this.StandbyStart();

        this.RequestManager.post(window.appRoot + "Password/SendConfirmationData",
            {
                "jsonData": JSON.stringify(this.confirmationData)
            },
            lang.hitch(this, this._onSendRequestResponse),
            lang.hitch(this, this._onSendRequestError),
            false            
        );
    }

    
    private _onSendRequestResponse(response: object): void {
        this.StandbyStop();
        //console.log("_onSendRequestResponse", response);

        this.showErrorMessage("");

        this.UiModder.domClass.add(this.sectionInputForm, "w3-hide");
        this.UiModder.domClass.remove(this.sectionResetComplete, "w3-hide");
    }

    private _onSendRequestError(error: more.requestErrorMessage): void {
        this.StandbyStop();
        this.showErrorMessage(error.Message);
        console.error("_onSendRequestError", error.url, error.Message);
    }

    private _onChange_PasswordChangeForm(valid: boolean): void {
        
        this._onChangeInputs();
    }

    private _onChangeInputs(newValue?: string): void {
        this.showErrorMessage("");

        this.submitBtn.setReadonly(!(this.passwordChangeForm.isValid() && !!this.confirmationCodeInput.getValue()));
        
    }

    showErrorMessage(message?: string) {
        if (message == null || typeof (message) == "undefined" || message == "") {
            this.txtErrorMessage.textContent = "";
            this.UiModder.domClass.add(this.sectionErrorMessage, "w3-hide");
        } else {
            this.txtErrorMessage.textContent = message;
            this.UiModder.domClass.remove(this.sectionErrorMessage, "w3-hide");
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);


        this.txtResetCompleteMessage.innerHTML = TranslationHelpers.translate("PwdReset__ConfirmReset_CompleteMessage");
        this.passwordChangeForm.setup({ useOldPassword: false });
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

}

export default mdsWidget(PwdReset_ConfirmReset);